<template>
  <div class="DMaterial">
    <div class="inner_center">
      <h2 class="headline">网罗流行3D精品素材 高品质可商用</h2>
      <div class="subhead">{{ THREE_D.MATERIAL_NUM }}素材库持续上新，紧跟时下流行设计，多行业、多分类、多场景、多格式全覆盖</div>

      <div class="swiper-bg">
        <DMaterialSwiper
          :banner="banner"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DMaterialSwiper from '@/components/3d/d-material/d-material-swiper'
import {THREE_D} from "@/constant/3d/3D";
export default {
  name: "DMaterial",
  components:{
    DMaterialSwiper
  },
  data(){
    return{
      banner:[
        {
          id: 0,
          link:'//js.chaopx.com/chaotu/3d/material/material%40case1.png',
        },
        {
          id: 1,
          link:'//js.chaopx.com/chaotu/3d/material/material%40case2.png',
        },
        {
          id: 2,
          link:'//js.chaopx.com/chaotu/3d/material/material%40case3.png',
        },
        {
          id: 3,
          link:'//js.chaopx.com/chaotu/3d/material/material%40case4.png',
        },
        {
          id: 0,
          link:'//js.chaopx.com/chaotu/3d/material/material%40case5.png',
        },

      ],
      THREE_D
    }
  }
}
</script>

<style lang="scss" scoped>
.DMaterial{
  @include BgImage(100%,940px,'3d/material-bg.jpg',1);


  .inner_center{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 1220px !important;
    overflow: hidden;
  }

  .headline{
    font-size: 44px;
    font-weight: bold;
    color: #21222E;
    line-height: 59px;
    letter-spacing: 1px;
    text-align: center;
    margin: 72px 0 12px;
  }

  .subhead{
    font-size: 18px;
    color: #373842;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: center;
  }

  .swiper-bg{
    @include BgImage(1268px,682px,'3d/material-center-bg.png');
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 16px;
    box-sizing: border-box;
    margin-left: -20px;
  }
}
</style>
